import React from 'react';
import { IconSvgProps } from '@models/common';

const TextPaste: React.FC<IconSvgProps> = (props) => {
  const { size = 20, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M13.332 3.33301H14.9987C15.4407 3.33301 15.8646 3.5086 16.1772 3.82116C16.4898 4.13372 16.6654 4.55765 16.6654 4.99967V16.6663C16.6654 17.1084 16.4898 17.5323 16.1772 17.8449C15.8646 18.1574 15.4407 18.333 14.9987 18.333H4.9987C4.55667 18.333 4.13275 18.1574 3.82019 17.8449C3.50763 17.5323 3.33203 17.1084 3.33203 16.6663V4.99967C3.33203 4.55765 3.50763 4.13372 3.82019 3.82116C4.13275 3.5086 4.55667 3.33301 4.9987 3.33301H6.66536M7.5013 1.66699H12.5013C12.9615 1.66699 13.3346 2.04009 13.3346 2.50033V4.16699C13.3346 4.62723 12.9615 5.00033 12.5013 5.00033H7.5013C7.04106 5.00033 6.66797 4.62723 6.66797 4.16699V2.50033C6.66797 2.04009 7.04106 1.66699 7.5013 1.66699Z'
        stroke='currentColor'
        strokeWidth='1.66667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default TextPaste;
